import { Breadcrumbs, Stack } from "@mui/material";
import DrawerRight from "./Drawer";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import { toast } from "react-toastify";

const BreadCrumbs = ({ breadcrumbs }) => {
  const [message, setMessage] = useState("");
  const [socket, setSocket] = useState(null);
  const token = localStorage.getItem("access_token");
  const user = token ? jwtDecode(token) : null;
  const [invisible, setInvisible] = useState(true);

  const location = useLocation();
  const currentPath = location?.pathname.split("/", 3).join("/");

  useEffect(() => {
    if (!user?.user_id) return;
    let wsBase = (process.env.REACT_APP_WEB_SOCKET_URL || "ws://localhost:8000").replace(/\/+$/, "");
    if (wsBase.startsWith("http://")) {
      wsBase = wsBase.replace("http://", "ws://");
    } else if (wsBase.startsWith("https://")) {
      wsBase = wsBase.replace("https://", "wss://");
    }
    const serverUrl = `${wsBase}/ws/notifications/?user=${user.user_id}&token=${token}`;
    let ws = null;
    try {
      ws = new WebSocket(serverUrl);
    } catch (err) {
      console.error("Failed to construct WebSocket:", err);
      return;
    }

    ws.onopen = () => {
      const authMessage = JSON.stringify({ token: token, user_id: user.user_id });
      ws.send(authMessage);
    };

    ws.onmessage = (event) => {
      try {
        const receivedMessage = event.data;
        if (receivedMessage) {
          const parsed = JSON.parse(receivedMessage);
          if (parsed?.notifications || parsed?.type === "notification") {
            toast.success("A new notification");
            setInvisible(false);
          }
          setMessage(parsed);
        }
      } catch (e) {
        // ignore
      }
    };

    ws.onclose = () => { };

    ws.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

    setSocket(ws);

    return () => {
      if (ws) {
        ws.close();
      }
    };
  }, [token, user?.user_id]);


  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        px: 2,
        mt: 2,
      }}
    >
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={
          <span style={{ color: "#535660", fontWeight: "700" }}>/</span>
        }
      >
        {breadcrumbs?.map((item, index) => {
          return (
            <Link
              underline="hover"
              to={item.link}
              padding={2}
              key={index}
              style={{
                textDecoration: "none",
                fontWeight: "700",
                color: currentPath === item.link ? "#BCBEC1" : "#535660",
              }}
            >
              {item.name}
            </Link>
          );
        })}
      </Breadcrumbs>
      <DrawerRight invisible={invisible} message={message} />
    </Stack>
  );
};

export default BreadCrumbs;
